// extracted by mini-css-extract-plugin
export var card = "_kn-5";
export var cardSelected = "_kn-4";
export var image = "_kn-3";
export var modal = "_kn-0";
export var modalContent = "_kn-1";
export var table = "_kn-2";